let counter = 0;
// Since multiple instances of this library will break anyway because of wasm this is probably good enough
export function createUniqueId() {
    return `vaReportComponentContainer${counter++}`;
}
